<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
  import EN from "./assets/lang/EN.json";
  import CH from "./assets/lang/CH.json";
  export default {
    name: 'App',
    created() {
      if(sessionStorage.getItem('Internationalization')=='EN'){
        this.$root.language = EN;
      }else{
        this.$root.language = CH;
      }
    }
  }
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
ul, ol, li {list-style: none;}
</style>
